import React, { useEffect, useMemo, useState } from "react";
import { Drawer, Tabs } from "antd";
import { MyLoader } from "Components/MyLoader/MyLoader";
import { MyList } from "Components/MyList/MyList";
import { errorNotification } from "Components/MyNotification";
import WorksApi from "Api/WorksApi/WorksApi";
import ProjectApi from "Api/ProjectApi/ProjectApi";
import { MyInput } from "Components/MyInput/MyInput";

export const DrawerWrapperWithLoader = ({
  projectId = "",
  title = "",
  open = false,
  setOpen = () => {},
  width = "",
  placement = "left",
  padding = "",
  destroyOnHidden = true,
  push = "",
  activeId = "",
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [listOfWorks, setListOfWorks] = useState([]);
  const [listOfMaterials, setListOfMaterials] = useState([]);
  const [valueOfInputWorks, setValueOfInputWorks] = useState("");
  const [valueOfInputMaterials, setValueOfInputMaterials] = useState("");
  useEffect(() => {
    const fetchFunction = async () => {
      try {
        setIsLoading(true);
        const works = await WorksApi.getAllWorksForList(projectId);
        const materials = await ProjectApi.findAllMaterialsForProject(
          1,
          "",
          projectId,
          1000,
        );

        if (works.status === "fail" || materials.status === "fail") {
          errorNotification(works.message || materials.message);
          return;
        }
        setListOfWorks(works.dto.works);
        setListOfMaterials(materials.dto);
      } catch (err) {
        errorNotification(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    if (open) {
      fetchFunction();
    }
  }, [open]);

  const filteredWorks = useMemo(() => {
    let result = [];
    if (open) {
      if (valueOfInputWorks) {
        result = listOfWorks.filter((el) =>
          el.title
            .trim()
            .toLowerCase()
            .includes(valueOfInputWorks.trim().toLowerCase()),
        );
      } else {
        result = listOfWorks;
      }
    }
    return result;
  }, [valueOfInputWorks, listOfWorks, open]);
  const filteredMaterials = useMemo(() => {
    let result = [];
    if (open) {
      if (valueOfInputMaterials) {
        result = listOfMaterials.filter((el) =>
          el.nomenclature
            .trim()
            .toLowerCase()
            .includes(valueOfInputMaterials.trim().toLowerCase()),
        );
      } else {
        result = listOfMaterials;
      }
    }
    return result;
  }, [valueOfInputMaterials, listOfMaterials, open]);

  return (
    <Drawer
      title={title}
      placement={placement}
      mask={false}
      width={width}
      open={open}
      onClose={() => {
        setOpen();
      }}
      destroyOnHidden={destroyOnHidden}
      styles={{
        body: {
          padding: padding,
          overflow: "hidden",
          overflowY: "none",
        },
      }}
      push={push}
    >
      {isLoading ? (
        <MyLoader centered={true} />
      ) : (
        <Tabs
          centered
          className="my-custom-materials-tabs"
          defaultActiveKey="1"
          items={[
            {
              label: `Перелік робіт`,
              key: 1,
              children: (
                <>
                  <MyInput
                    placeholder="Пошук робіт в кошторисі"
                    value={valueOfInputWorks}
                    onChange={(e) => setValueOfInputWorks(e.target.value)}
                  />
                  <MyList
                    list={filteredWorks}
                    activeId={activeId}
                    type="works"
                  />
                </>
              ),
            },
            {
              label: `Матеріали`,
              key: 2,
              children: (
                <>
                  <MyInput
                    placeholder="Пошук матеріалів по проекту"
                    value={valueOfInputMaterials}
                    onChange={(e) => setValueOfInputMaterials(e.target.value)}
                    margin="0 0 10px 0 "
                  />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "0 30px",
                    }}
                  >
                    <span>Найменування</span>
                    <span>Залишок</span>
                  </div>
                  <MyList
                    list={filteredMaterials}
                    activeId={activeId}
                    type="materials"
                  />
                </>
              ),
            },
          ]}
        />
      )}
    </Drawer>
  );
};
